import SearchIcon from '@mui/icons-material/Search';

const icons = {
  SearchIcon
};

const ProvierSearch = {
  id: 'ProvierSearch',
  type: 'group',
  children: [
    {
      id: 'ProvierSearch',
      title: 'Provider Search',
      type: 'item',
      url: '/Provider-Search',
      icon: icons.SearchIcon,
    }
  ]
};

export default ProvierSearch;
